"use client";
import { useEffect, useRef, useState } from "react";
import { FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";
import Img from "./Img";

export default function CardSlide({ children }: React.PropsWithChildren) {
  const container = useRef<HTMLDivElement>(null);
  const [activeCard, setActiveCard] = useState(0);
  const [isLeftButtonActive, setIsLeftButtonActive] = useState(false);
  const [isRightButtonActive, setIsRightButtonActive] = useState(true);

  const moveSlide = (index: number) => {
    if (!container.current) {
      return;
    }

    const children = Array.from(container.current.children);
    if (children.length && children[index]) {
      const currentTranslateMatch =
        container.current.style.transform?.match(/-?\d+/);
      const currentTranslate = currentTranslateMatch
        ? parseInt(currentTranslateMatch[0])
        : 0;

      const containerLeft =
        container.current.getBoundingClientRect().left - currentTranslate;

      const childClientRect = children[index].getBoundingClientRect();
      const childLeft = childClientRect.left - currentTranslate;
      const childHalfWidth = childClientRect.width / 2;

      container.current.style.transform = `translateX(${
        // moves container left to the window center
        window.innerWidth / 2 -
        containerLeft -
        // moves child center to the window center
        (childLeft - containerLeft + childHalfWidth)
      }px)`;
    }
  };

  useEffect(() => {
    moveSlide(0);
  }, []);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const handleResize = () => {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => {
        moveSlide(activeCard);
      }, 200);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }

      window.removeEventListener("resize", handleResize);
    };
  }, [activeCard]);

  const changeSlideCard = (inc: -1 | 1) => {
    if (!container.current) {
      return;
    }

    const childCount = container.current.children.length;
    const nextActiveCard = activeCard + inc;

    if (-1 < nextActiveCard && nextActiveCard < childCount) {
      moveSlide(nextActiveCard);

      setActiveCard(nextActiveCard);
      setIsLeftButtonActive(nextActiveCard > 0);
      setIsRightButtonActive(nextActiveCard < childCount - 1);
    }
  };

  return (
    <div className="overflow-hidden flex relative max-w-full pt-4 pb-16 lg:pb-4">
      <div
        className="
        z-1 absolute bottom-0 left-0 right-1/2 flex justify-center items-center
        lg:top-0 lg:right-auto lg:w-20"
      >
        <div className="absolute top-0 left-0 bottom-0 w-14 bg-white"></div>

        <Img
          id="wave-home-cover"
          classImage="absolute -left-[550px] max-w-none max-h-none ml-14 rotate-90 hidden lg:block"
        />

        <button
          className="z-10 relative button-outlined"
          disabled={!isLeftButtonActive}
          aria-label="Ugrás az előző elemhez"
          onClick={() => changeSlideCard(-1)}
        >
          <FaAnglesLeft size={20} />
        </button>
      </div>

      <div
        ref={container}
        className="inline-flex mx-auto max-w-5xl transition-transform"
      >
        {children}
      </div>

      <div
        className="
        z-1 absolute bottom-0 right-0 left-1/2 flex justify-center items-center
        lg:top-0 lg:left-auto lg:w-20"
      >
        <div className="absolute top-0 right-0 bottom-0 w-14 bg-white"></div>

        <Img
          id="wave-home-cover"
          classImage="absolute -right-[550px] max-w-none max-h-none mr-14 -rotate-90 hidden lg:block"
        />

        <button
          className="z-10 relative button-outlined"
          disabled={!isRightButtonActive}
          aria-label="Ugrás a következő elemhez"
          onClick={() => changeSlideCard(1)}
        >
          <FaAnglesRight size={20} />
        </button>
      </div>
    </div>
  );
}
